module.exports = __webpack_public_path__ + "static/media/residentiel-3.ebc2991d.jpg";